export default __webpack_public_path__ + "static/media/icon-bank-wire.4abef1ca.svg";